import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import { INITIAL } from '../../config';
import { useFormContext } from '../../components/form/context';

import type { TErrorSendLayout } from './models';

const fontSizeDesktop = 30;
const fontSizeMobile = 22;
const lineHeightDesktop = 36;
const lineHeightMobile = 26;

export const ErrorSendLayout: FC<TErrorSendLayout> = ({
    Aligner,
    Button,
    IconError,
    Text,
    isMobile,
    styles,
}) => {
    const { updateStatus } = useFormContext();

    const fontSize = isMobile ? fontSizeMobile : fontSizeDesktop;
    const lineHeight = isMobile ? lineHeightMobile : lineHeightDesktop;

    return (
        <Aligner>
            <IconError className={cn(styles.external, styles.icon)} />
            <Text
                className={cn(styles.external, styles.title)}
                fontSize={fontSize}
                fontWeight={7}
                lineHeight={lineHeight}
                tag="h2"
            >
                Похоже, что-то пошло не так
            </Text>
            <Text className={cn(styles.external, styles.subtitle)}>
                Пожалуйста, попробуйте еще раз
            </Text>
            <Button
                className={cn(styles.external, styles.actionButton)}
                onClick={() => updateStatus(INITIAL)}
                view="outlined"
            >
                Попробовать ещё раз
            </Button>
        </Aligner>
    );
};
